"use strict";

// const { JenisPengadaan } = require('./../../server/lib/shareLib')
const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API

function getItemFromList(list, val) {
  const ls = list.find(el => el.value.includes(val))
  return ls.items
}

async function getJadwalLelang(paketPenyediaId) {
  let result = null
  await axios.get(apiUrl+`/api/rup/paket/jadwal/${paketPenyediaId}`)
  .then( (response) => {
      // console.log("List jadwal: ", response.data);      
      // store.dispatch('lelang/assignJadwal', response.data)
      result = response.data;
  });
  return result
}

async function getPesertaLelang(paketPenyediaId) {
  let result = null
  await axios.get(apiUrl+`/api/rup/paket/peserta/${paketPenyediaId}`)
  .then( (response) => {
      // console.log("List jadwal: ", response.data);      
      // store.dispatch('lelang/assignJadwal', response.data)
      result = response.data;
  });
  return result
}

async function getPesertaLelangNama(paketPenyediaId) {
  let result = null
  await axios.get(apiUrl+`/api/rup/paket/pesertanama/${paketPenyediaId}`)
  .then( (response) => {
      console.log("Peserta Nama: ", response.data);      
      // store.dispatch('lelang/assignJadwal', response.data)
      result = response.data;
  });
  return result
}

const itemsMetodePemilihan = [
  { text: "Penunjukan Langsung", value: 'TLA' },
  { text: "Pengadaan Langsung", value: 'PLA' },
  { text: "Tender", value: 'TEN' },
  { text: "Seleksi",value: 'SEL'},
];

const itemsJenisPengadaan = //JenisPengadaan
[
  { text: "Pengadaan Barang", value: 'BAR', limitPLA: 500000000, kode: '14' },
  { text: "Konstruksi", value: 'KON', limitPLA: 500000000, kode: '11' },
  { text: "Jasa Konsultansi", value: 'KOL', limitPLA: 300000000, kode: '12' },
  { text: "Jasa Lainnya", value: 'LAI', limitPLA: 500000000, kode: '13' },  
];

const itemsMetodeEvaluasi = [
  {
    value: [ 'BAR', 'KON', 'LAI' ],
    items: [
      { text: "Sistem Nilai", value: 'NIL' },
      { text: "Penilaian Biaya Sesuai Umur Ekonomis", value: 'EKO' },
      { text: "Harga Terendah", value: 'REN' },
      { text: "Harga Terendah Dengan Passing Grade", value: 'RENPSG' },
      { text: "Sistem Nilai Dengan Passing Grade", value: 'NILPSG' }
    ]
  },  
  {
    value: [ 'KOL' ],
    items: [
      { text: "Kualitas dan Biaya", value: 'KUB' },
      { text: "Kualitas", value: 'KUA' },
      { text: "Pagu Anggaran", value: 'PAG' },
      { text: "Biaya Terendah", value: 'REN' },
      { text: "Biaya Terendah Dengan Passing Grade", value: 'RENPSG' },
      { text: "Kualitas dan Biaya Dengan Passing Grade", value: 'NILPSG' }
    ]
  },  
];

const listJadwalPengadaan = [
  { // Penunjukan Langsung
    value: 'TLA',
    keterangan: 'Penunjukan Langsung',
    items: [
      { tahap: "Undangan", urut: 1, fitur: [], printout: "rpt/tla/undangan" },                                                  // Pilih Vendor sesuai KBLI
      { tahap: "Pemberian Penjelasan / Aanwizjing", urut: 2, fitur: [], printout: "" },                         // Chat tipe Penjelasan
      { tahap: "Pemasukan Dokumen Penawaran", urut: 3, fitur: [], printout: "" },                               // Upload Dok Teknis dan Biaya
      { tahap: "Pembukaan dan Evaluasi Dokumen Penawaran", urut: 4, fitur: [], printout: "" },                  // Evaluasi Teknis dan Biaya
      { tahap: "Undangan Klarifikasi dan Negosiasi Teknis dan Biaya", urut: 5, fitur: [], printout: "" },       
      { tahap: "Hasil Klarifikasi dan Negosiasi Teknis dan Biaya", urut: 6, fitur: [], printout: "" },                // Chat tipe Nego 
      { tahap: "Berita Acara Klarifikasi dan Negosiasi", urut: 7, fitur: [], printout: "" },                // Chat tipe Nego 
      { tahap: "Penetapan Penyedia", urut: 8, fitur: [], printout: "" },                   // Penetapan Pemenang
      { tahap: "Berita Acara Penunjukan Langsung", urut: 9, fitur: [], printout: "" },                         // Upload/Download BA
      { tahap: "Surat Penunjukan Penyedia Barang dan Jasa (SPPBJ)", urut: 10, fitur: [], printout: "" },            // Upload/Download SPPBJ
      { tahap: "Penandatanganan Surat Perintah Kerja (SPK)/Perjanjian", urut: 11, fitur: [], printout: "" },    // Upload/Download SPK
      { tahap: "Surat Perintah Mulai Kerja (SPMK)", urut: 12, fitur: [], printout: "" },                        // Upload/Download SPMK
    ]
  },
  { // Pengadaan Langsung
    value: 'PLA',
    keterangan: 'Pengadaan Langsung',
    items: [
      { tahap: "Undangan", urut: 1, fitur: [], printout: "/printout/tla/undangan" },                                                  // Pilih vendor sesuai KBLI
      { tahap: "Pemberian Penjelasan / Aanwizjing", urut: 2, fitur: [], printout: "" },
      { tahap: "Pemasukan Dokumen Penawaran", urut: 3, fitur: [], printout: "" },                               // Upload Dok Administrasi, Teknis dan Biaya
      { tahap: "Pembukaan dan Evaluasi Dokumen Penawaran", urut: 4, fitur: [], printout: "" },                  // Evaluasi Administrasi, Teknis dan Biaya
      { tahap: "Pengumuman Hasil Evaluasi", urut: 5, fitur: [], printout: "" },                                 
      { tahap: "Undangan Klarifikasi dan Negosiasi", urut: 6, fitur: [], printout: "" },                         
      { tahap: "Berita Acara Klarifikasi dan Negosiasi", urut: 7, fitur: [], printout: "" },                    // Upload/Download BA
      { tahap: "Berita Acara Pengadaan Langsung", urut: 8, fitur: [], printout: "" },                           // Upload/Download BA
      { tahap: "Penandatanganan Surat Perintah Kerja (SPK)", urut: 9, fitur: [], printout: "" },                // Upload/Download SPK
      { tahap: "Surat Perintah Mulai Kerja (SPMK)", urut: 10, fitur: [], printout: "" },                        // Upload/Download SPMK
    ]
  },
  { // Tender Prakualifikasi
    value: 'PTEN',
    keterangan: 'Tender Prakualifikasi',
    items: [
      { tahap: "Pengumuman Prakualifikasi", urut: 1, fitur: [], printout: "" },
      { tahap: "Pendaftaran dan Pengambilan Dokumen Prakualifikasi", urut: 2, fitur: [], printout: "" },
      { tahap: "Pemberian Penjelasan / Aanwizjing", urut: 3, fitur: [], printout: "" },
      { tahap: "Pemasukan Dokumen Prakualifikasi", urut: 4, fitur: [], printout: "" },
      { tahap: "Pembukaan Dokumen Prakualifikasi", urut: 5, fitur: [], printout: "" },
      { tahap: "Evaluasi Dokumen Kualifikasi", urut: 6, fitur: [], printout: "" },
      { tahap: "Undangan Pembuktian Kualifikasi", urut: 7, fitur: [], printout: "" },
      { tahap: "Pembuktian Kualifikasi", urut: 8, fitur: [], printout: "" },
      { tahap: "Penetapan Hasil Kualifikasi", urut: 9, fitur: [], printout: "" },
      { tahap: "Pengumuman Hasil Kualifikasi", urut: 10, fitur: [], printout: "" },
      { tahap: "Masa Sanggah Kualifikasi", urut: 11, fitur: [], printout: "" },
      { tahap: "Berita Acara Sanggah Kualifikasi", urut: 12, fitur: [], printout: "" },
      { tahap: "Undangan Tender", urut: 13, fitur: [], printout: "" },
      { tahap: "Pendaftaran dan Pengambilan Dokumen Tender", urut: 14, fitur: [], printout: "" },
      { tahap: "Pemberian Penjelasan / Aanwizjing", urut: 15, fitur: [], printout: "" },
      { tahap: "Pemasukan Dokumen Penawaran Administrasi dan Teknis (File 1)", urut: 16, fitur: [], printout: "" },
      { tahap: "Pembukaan Dokumen Penawaran Administrasi dan Teknis", urut: 17, fitur: [], printout: "" },
      { tahap: "Evaluasi Dokumen Penawaran Administrasi dan Teknis", urut: 18, fitur: [], printout: "" },
      { tahap: "Undangan Pembuktian Dokumen Administrasi dan Teknis", urut: 19, fitur: [], printout: "" },
      { tahap: "Pengumuman Hasil Evaluasi Administrasi dan Teknis", urut: 20, fitur: [], printout: "" },
      { tahap: "Pemasukan Dokumen Penawaran Harga (File 2)", urut: 21, fitur: [], printout: "" },
      { tahap: "Pembukaan Dokumen Penawaran Harga", urut: 22, fitur: [], printout: "" },
      { tahap: "Evaluasi Dokumen Penawaran Harga", urut: 23, fitur: [], printout: "" },
      { tahap: "Penetapan Pemenang", urut: 24, fitur: [], printout: "" },
      { tahap: "Pengumuman Pemenang", urut: 25, fitur: [], printout: "" },
      { tahap: "Masa Sanggah", urut: 26, fitur: [], printout: "" },
      { tahap: "Masa Sanggah Banding (Untuk Pekerjaan Konstruksi)", urut: 27, fitur: [], printout: "" },
      { tahap: "Berita Acara Sanggah", urut: 28, fitur: [], printout: "" },
      { tahap: "Undangan Klarifikasi Negosiasi Teknis dan Biaya", urut: 29, fitur: [], printout: "" },
      { tahap: "Klarifikasi Negosiasi Teknis dan Biaya", urut: 30, fitur: [], printout: "" },
      { tahap: "Berita Acara Klarifikasi dan Negosiasi Teknis dan Biaya", urut: 31, fitur: [], printout: "" },
      { tahap: "Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)", urut: 32, fitur: [], printout: "" },                                                    
      { tahap: "Penandatanganan Kontrak (SPK) / Perjanjian", urut: 33, fitur: [], printout: "" },                                                     
      { tahap: "Penandatanganan Perintah Mulai Kerja (SPMK) / Surat Pesanan", urut: 34, fitur: [], printout: "" }                                                     
    ]
    
  },
  { // Tender Pasca 1 File
    value: 'KTEN',
    keterangan: 'Tender Pasca kualifikasi 1 File',
    items: [
      { tahap: "Pengumuman Tender", urut: 1, fitur: [], printout: '/printout/kten/pengumuman-tender/' },
      { tahap: "Pendaftaran dan Pengambilan Dokumen", urut: 2, fitur: [], printout: "/printout/kten/pembukaan-dokumen-penawaran/" },
      { tahap: "Pemberian Penjelasan / Aanwizjing", urut: 3, fitur: [], printout: "/printout/kten/aanwizjing/"},
      { tahap: "Pemasukan Dokumen Penawaran", urut: 4, fitur: [], printout: "/printout/kten/pemasukan-dokumen-penawaran/" },
      { tahap: "Pembukaan Dokumen Penawaran", urut: 5, fitur: [], printout: "/printout/kten/pembukaan-dokumen-penawaran/" },
      { tahap: "Evaluasi Administrasi, Teknis dan Biaya", urut: 6, fitur: [], printout: "/printout/kten/evaluasi-administrasi-teknis-harga-dan-kualifikasi/" },
      { tahap: "Undangan Pembuktian Kualifikasi", urut: 7, fitur: [], printout: "/printout/kten/undangan-pembuktian-kualifikasi/" },
      { tahap: "Pembuktian Kualifikasi", urut: 8, fitur: [], printout: "/printout/kten/pembuktian-kualifikasi/" },
      { tahap: "Penetapan Pemenang", urut: 9, fitur: [], printout: "/printout/kten/penetapan-pemenang/" },
      { tahap: "Pengumuman Pemenang", urut: 10, fitur: [], printout: "/printout/kten/pengumuman-pemenang/" },
      { tahap: "Masa Sanggah", urut: 11, fitur: [], printout: "/printout/kten/masa-sanggah/" },
      { tahap: "Berita Acara Sanggah", urut: 12, fitur: [], printout: "/printout/kten/berita-acara-sanggah/" },
      { tahap: "Undangan Klarifikasi dan Negosiasi Teknis dan Biaya", urut: 13, fitur: [], printout: "/printout/kten/undangan-klarifikasi-dan-negosisasi-teksins-dan-biaya/" },
      { tahap: "Klarifikasi Negosiasi Teknis dan Biaya", urut: 14, fitur: [], printout: "/printout/kten/klarifikasi-negosiasi-teknis-dan-biaya/" },
      { tahap: "Berita Acara Klarifikasi dan Negosiasi Teknis dan Biaya", urut: 15, fitur: [], printout: "/printout/kten/berita-acara-klarifikasi-dan-negosiasi-teknis-dan-biaya/" },
      { tahap: "Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)", urut: 16, fitur: [], printout: "/printout/kten/sppbj/" },
      { tahap: "Penandatanganan Dokumen Kontrak (SPK) / Perjanjian", urut: 17, fitur: [], printout: "/printout/kten/spk/" },
      { tahap: "Penandatanganan Surat Perintah Mulai Kerja (SPMK) / Surat Pesanan", urut: 18, fitur: [], printout: "/printout/kten/spmk/" },
    ]
  },
  { // Tender pasca 2 file
    value: 'K2TEN',
    keterangan: 'Tender Prakualifikasi 2 File',
    items: [
      { tahap: "Pengumuman Tender", urut: 1, fitur: [], printout: "" },
      { tahap: "Pendaftaran Dan Pengambilan Dokumen", urut: 2, fitur: [], printout: "" },
      { tahap: "Pemberian Penjelasan / Aanwizjing", urut: 3, fitur: [], printout: "" },
      { tahap: "Pemasukan Dokumen Penawaran Administrasi Dan Teknis (file 1)", urut: 4, fitur: [], printout: "" },
      { tahap: "Pembukaan Dokumen Penawaran Administrasi Dan Teknis", urut: 5, fitur: [], printout: "" },
      { tahap: "Evaluasi Dokumen Administrasi Dan Teknis", urut: 6, fitur: [], printout: "" },
      { tahap: "Undangan Pembuktian Kualifikasi", urut: 7, fitur: [], printout: "" },
      { tahap: "Pengumuman Hasil Evaluasi Administrasi dan Teknis", urut: 8, fitur: [], printout: "" },
      { tahap: "Pemasukan Dokumen Penawaran Harga (file 2)", urut: 9, fitur: [], printout: "" },
      { tahap: "Pembukaan Dokumen Penawaran Harga", urut: 10, fitur: [], printout: "" },
      { tahap: "Evaluasi Dokumen Penawaran Harga", urut: 11, fitur: [], printout: "" },
      { tahap: "Penetapan Pemenang", urut: 12, fitur: [], printout: "" },
      { tahap: "Pengumuman Pemenang", urut: 13, fitur: [], printout: "" },
      { tahap: "Masa Sanggah", urut: 14, fitur: [], printout: "" },
      { tahap: "Masa Sanggah Banding (Untuk Pekerjaan Konstruksi)", urut: 15, fitur: [], printout: "" },
      { tahap: "Berita Acara Sanggah", urut: 16, fitur: [], printout: "" },
      { tahap: "Undangan Klarifikasi Negosiasi Teknis Dan Biaya", urut: 17, fitur: [], printout: "" },
      { tahap: "Klarifikasi Negosiasi Teknis Dan Biaya", urut: 18, fitur: [], printout: "" },
      { tahap: "Berita Acara Klarifikasi Negosiasi Teknis Dan Biaya", urut: 19, fitur: [], printout: "" },
      { tahap: "Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)", urut: 20, fitur: [], printout: "" },
      { tahap: "Penandatanganan Kontrak (spk)/perjanjian", urut: 21, fitur: [], printout: "" },
      { tahap: "Penandatanganan Perintah Mulai Kerja / Surat Pesanan", urut: 22, fitur: [], printout: "" },
    ]
  },
  { // Seleksi Prakualifikasi
    value: 'PSEL',
    keterangan: 'Seleksi Prakualifikasi',
    items: [
      { tahap: "Pengumuman Prakualifikasi", urut: 1, fitur: [], printout: "" },
      { tahap: "Pendaftaran dan Pengambilan Dokumen Prakualifikasi", urut: 2, fitur: [], printout: "" },
      { tahap: "Pemberian Penjelasan / Aanwizjing", urut: 3, fitur: [], printout: "" },
      { tahap: "Pemasukan Dokumen Prakualifikasi", urut: 4, fitur: [], printout: "" },
      { tahap: "Pembukaan Dokumen Prakualifikasi", urut: 5, fitur: [], printout: "" },
      { tahap: "Evaluasi Dokumen Kualifikasi", urut: 6, fitur: [], printout: "" },
      { tahap: "Undangan Pembuktian Kualifikasi", urut: 7, fitur: [], printout: "" },
      { tahap: "Pembuktian Kualifikasi", urut: 8, fitur: [], printout: "" },
      { tahap: "Penetapan Hasil Kualifikasi", urut: 9, fitur: [], printout: "" },
      { tahap: "Pengumuman Hasil Kualifikasi", urut: 10, fitur: [], printout: "" },
      { tahap: "Masa Sanggah Kualifikasi", urut: 11, fitur: [], printout: "" },
      { tahap: "Berita Acara Sanggah Kualifikasi", urut: 12, fitur: [], printout: "" },
      { tahap: "Undangan Tender", urut: 13, fitur: [], printout: "" },
      { tahap: "Pendaftaran dan Pengambilan Dokumen Tender", urut: 14, fitur: [], printout: "" },
      { tahap: "Pemberian Penjelasan / Aanwizjing", urut: 15, fitur: [], printout: "" },
      { tahap: "Pemasukan Dokumen Penawaran Administrasi dan Teknis (File 1)", urut: 16, fitur: [], printout: "" },
      { tahap: "Pembukaan Dokumen Penawaran Administrasi dan Teknis", urut: 17, fitur: [], printout: "" },
      { tahap: "Evaluasi Dokumen Penawaran Administrasi dan Teknis", urut: 18, fitur: [], printout: "" },
      { tahap: "Undangan Pembuktian Dokumen Administrasi dan Teknis", urut: 19, fitur: [], printout: "" },
      { tahap: "Pengumuman Hasil Evaluasi Administrasi dan Teknis", urut: 20, fitur: [], printout: "" },
      { tahap: "Pemasukan Dokumen Penawaran Biaya (File 2)", urut: 21, fitur: [], printout: "" },
      { tahap: "Pembukaan Dokumen Penawaran Biaya", urut: 22, fitur: [], printout: "" },
      { tahap: "Evaluasi Dokumen Penawaran Biaya", urut: 23, fitur: [], printout: "" },
      { tahap: "Penetapan Pemenang", urut: 24, fitur: [], printout: "" },
      { tahap: "Pengumuman Pemenang", urut: 25, fitur: [], printout: "" },
      { tahap: "Masa Sanggah", urut: 26, fitur: [], printout: "" },
      // { tahap: "Masa Sanggah Banding (Untuk Pekerjaan Konstruksi)", urut: 27, fitur: [], printout: "" },
      { tahap: "Berita Acara Sanggah", urut: 28, fitur: [], printout: "" },
      { tahap: "Undangan Klarifikasi Negosiasi Teknis dan Biaya", urut: 29, fitur: [], printout: "" },
      { tahap: "Klarifikasi Negosiasi Teknis dan Biaya", urut: 30, fitur: [], printout: "" },
      { tahap: "Berita Acara Klarifikasi dan Negosiasi Teknis dan Biaya", urut: 31, fitur: [], printout: "" },
      { tahap: "Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)", urut: 32, fitur: [], printout: "" },                                                    
      { tahap: "Penandatanganan Kontrak (SPK) / Perjanjian", urut: 33, fitur: [], printout: "" },                                                     
      { tahap: "Penandatanganan Perintah Mulai Kerja (SPMK) / Surat Pesanan", urut: 34, fitur: [], printout: "" }   
    ]
  },
  { // Seleksi Pasca
    value: 'KSEL',
    keterangan: 'Seleksi Pasca Kualifikasi',
    items: [
      { tahap: "Pengumuman Tender", urut: 1, fitur: [], printout: "" },
      { tahap: "Pendaftaran dan Pengambilan Dokumen", urut: 2, fitur: [], printout: "" },
      { tahap: "Pemberian Penjelasan / Aanwizjing", urut: 3, fitur: [], printout: "" },
      { tahap: "Pemasukan Dokumen Penawaran", urut: 4, fitur: [], printout: "" },
      { tahap: "Pembukaan Dokumen Penawaran", urut: 5, fitur: [], printout: "" },
      { tahap: "Evaluasi Administrasi, Teknis dan Biaya", urut: 6, fitur: [], printout: "" },
      { tahap: "Undangan Pembuktian Kualifikasi", urut: 7, fitur: [], printout: "" },
      { tahap: "Pembuktian Kualifikasi", urut: 8, fitur: [], printout: "" },
      { tahap: "Penetapan Pemenang", urut: 9, fitur: [], printout: "" },
      { tahap: "Pengumuman Pemenang", urut: 10, fitur: [], printout: "" },
      { tahap: "Masa Sanggah", urut: 11, fitur: [], printout: "" },
      { tahap: "Berita Acara Sanggah", urut: 12, fitur: [], printout: "" },
      { tahap: "Undangan Klarifikasi dan Negosiasi Teknis dan Biaya", urut: 13, fitur: [], printout: "" },
      { tahap: "Klarifikasi Negosiasi Teknis dan Biaya", urut: 14, fitur: [], printout: "" },
      { tahap: "Berita Acara Klarifikasi dan Negosiasi Teknis dan Biaya", urut: 15, fitur: [], printout: "" },
      { tahap: "Surat Penunjukan Penyedia Barang/Jasa (SPPBJ)", urut: 16, fitur: [], printout: "" },
      { tahap: "Penandatanganan Dokumen Kontrak (SPK) / Perjanjian", urut: 17, fitur: [], printout: "" },
      { tahap: "Penandatanganan Surat Perintah Mulai Kerja (SPMK) / Surat Pesanan", urut: 18, fitur: [], printout: "" },
    ]
  }
];

const itemsKualifikasi = [
  { text: "Prakualifikasi", value: 'P' },
  { text: "Pascakualifikasi", value: 'K' },
  { text: "Pascakualifikasi 2 File", value: 'K2' }
];

const itemsKualifikasiTender = [
  { text: "Prakualifikasi", value: 'P' },
  { text: "Pascakualifikasi", value: 'K' },
  { text: "Pascakualifikasi 2 File", value: 'K2' }
];

const itemsKualifikasiSeleksi = [
  { text: "Prakualifikasi", value: 'P' },
  { text: "Pascakualifikasi", value: 'K' },
];
  


const itemsJenisKontrak = [
  {
    value: [ 'BAR', 'KON', 'LAI' ],
    items: [
      { text: "Lumpsum", value: 'LUM' },
      { text: "Harga Satuan", value: 'HST' },
      { text: "Gabungan Lumpsum dan Harga Satuan", value: 'GLH' },
      { text: "Turnkey", value: 'TUR' },
      { text: "Kontrak Payung", value: 'PAY' }
    ]
  },  
  {
    value: [ 'KOL' ],
    items: [
      { text: "Lumpsum", value: 'LUM' },
      { text: "Waktu Penugasan", value: 'WAK' },
      { text: "Kontrak Payung", value: 'PAY' },
      { text: "Lumpsum Gabungan", value: 'LUG' },
    ]
  },  
];

module.exports = { 
  getItemFromList, getJadwalLelang, getPesertaLelang, getPesertaLelangNama,
  itemsJenisPengadaan, itemsMetodePemilihan, itemsMetodeEvaluasi, listJadwalPengadaan, itemsKualifikasi, itemsKualifikasiTender,itemsKualifikasiSeleksi, itemsJenisKontrak
}